import { z } from 'zod'
import { apiFetch } from './client'

/**
 * Google Business Profile Account schema
 */
export const AccountSchema = z.object({
  id: z.number(),
  account_id: z.string(), // Google's account identifier (e.g., "accounts/123456789")
  account_name: z.string(),
  account_type: z.string(), // ORGANIZATION or PERSONAL
  created_at: z.string(),
  // Optional fields that may not always be present
  user_id: z.number().optional(),
  account_number: z.string().optional(), // Alternative name for account_id
  verification_state: z.string().optional(),
  vetting_status: z.string().optional(),
  updated_at: z.string().optional(),
})

export type Account = z.infer<typeof AccountSchema>

/**
 * Fetch all accounts for the current authenticated user.
 * Note: userId parameter is deprecated and ignored - uses JWT auth instead.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export async function fetchUserAccounts(_userId?: string): Promise<Account[]> {
  // Use /accounts/me which extracts user from JWT
  const data = await apiFetch<Account[]>('/accounts/me')
  return z.array(AccountSchema).parse(data)
}
